import { render, staticRenderFns } from "./modal-reviews.vue?vue&type=template&id=7c38f3f2&"
import script from "./modal-reviews.vue?vue&type=script&lang=js&"
export * from "./modal-reviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports